"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Trigger", {
  enumerable: true,
  get: function get() {
    return _Trigger.default;
  }
});
exports.findDOMNode = findDOMNode;
exports.findDOMNodePolyfill = findDOMNodePolyfill;
exports.getComponent = getComponent;
exports.getDisplayName = void 0;
exports.getModuleName = getModuleName;
exports.isOverReact18 = void 0;
exports.isPointsEq = isPointsEq;
exports.isValidChild = isValidChild;
exports.renderChildIfMatch = renderChildIfMatch;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _compareVersions = require("compare-versions");
var _htmlTags = _interopRequireDefault(require("html-tags"));
var _typeof = require("../data/typeof");
var _data = require("../data");
var _Trigger = _interopRequireDefault(require("./Trigger"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof2(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * 获取节点的类名
 * @param {*} child react 节点
 */
var getDisplayName = exports.getDisplayName = function getDisplayName(child) {
  if (!child || ! /*#__PURE__*/_react.default.isValidElement(child)) {
    return '';
  }
  // @ts-ignore
  return child.type.displayName || child.type.name || '';
};
/**
 * 获取模块的类名
 */
function getModuleName(source) {
  var modu = source.__esModule ? source.default : source;
  return modu.displayName || modu.name;
}
/**
 * 把  string, function, reactClass 的数据都转成可直接渲染的 reactNode
 * @param {String|Function|ReactClass} source 传入需要转换的数据
 * @param {Object} props 传入的属性或参数
 * @param {any} deconstruct 如果传入纯 function，是否解构参数
 * @return {Node}
 */
function getComponent(source) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var deconstruct = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  // 如果是个方法
  if ((0, _typeof.isFunction)(source)) {
    return deconstruct ? source.apply(void 0, (0, _toConsumableArray2.default)(Object.values(props))) : source(props);
  }
  if (!(0, _typeof.isObject)(source)) return source;
  // React.forwardRef 或者 ReactClass
  if (
  // @ts-ignore
  (0, _typeof.isObject)(source.type) && (0, _typeof.isFunction)(source.type.render)
  // @ts-ignore
  || (0, _typeof.isFunction)(source.type) && source.type.prototype && source.type.prototype.render) {
    // @ts-ignore
    return /*#__PURE__*/_react.default.createElement(source.type, _objectSpread(_objectSpread(_objectSpread({}, source.props), props), {}, {
      ref: source.ref
    }));
  }
  return source;
}
/**
 * 判断节点的类名是否符合要求
 * @param {*} child react 节点
 * @param {*} validTypes 符合要求的类型
 */
function isValidChild(child, validTypes) {
  if (! /*#__PURE__*/_react.default.isValidElement(child)) return false;
  return (Array.isArray(validTypes) ? validTypes : [validTypes]).some(function (v) {
    if (child.type === v) {
      return true;
    }
    return getDisplayName(child) === getModuleName(v);
  });
}
/**
 * 遍历 jsx，对符合 match 的节点进行操作
 * @param {*} children jsx 节点树
 * @param {*} match
 *  (child) => checkResponse
 * @param {*} render
 *  (child, checkResponse) => ReactNode
 */
function renderChildIfMatch(children, match, render) {
  var newChildren = _react.default.Children.map(children, function (child) {
    if (!child || !child.props) return child;
    var res = match(child);
    if (res) {
      return render(child, res);
    }
    if (child.props.children) {
      return /*#__PURE__*/_react.default.cloneElement(child, {}, renderChildIfMatch(child.props.children, match, render));
    }
    return child;
  });
  // 避免使用 React.Children.only 时报错
  if ((0, _data.getSaftyArray)(newChildren).length === 1) return newChildren[0];
  return newChildren;
}
function isPointsEq(a1, a2) {
  return a1[0] === a2[0] && a1[1] === a2[1];
}
var isOverReact18 = exports.isOverReact18 = function isOverReact18() {
  return (0, _compareVersions.compare)(_react.version, '18.0.0', '>=');
};
function findDOMNodePolyfill(component) {
  // 检查 component 是否存在
  if (!component) {
    return null;
  }
  var internalInstance = component._reactInternals || component._reactInternalFiber;
  function findActualDOMNode(instance) {
    if (!instance) {
      return null;
    }
    if (_htmlTags.default.includes(instance.elementType)) {
      return instance.stateNode;
    }
    // 如果不是 HTML5 标签类型，递归检查 child
    return findActualDOMNode(instance.child);
  }
  return findActualDOMNode(internalInstance);
}
function findDOMNode(component) {
  if (!isOverReact18()) return (0, _reactDom.findDOMNode)(component);
  return findDOMNodePolyfill(component);
}